import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { ReferenceRoomSettingsService } from '../service/reference-room-settings.service';
import { ReferenceRoomSettingsHelper } from '../reference-room-settings.helper';

@Component({
  selector: 'app-reference-room-settings-assign-no-room',
  standalone: true,
  imports: [CommonStandaloneModule, MatButtonModule],
  templateUrl: './reference-room-settings-no-room.component.html',
  styleUrl: './reference-room-settings-no-room.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferenceRoomSettingsNoRoomComponent {
  constructor(private rrsService: ReferenceRoomSettingsService) {}

  goToRoomManagement(): void {
    this.rrsService.setView(ReferenceRoomSettingsHelper.ReferenceRoomSettingsView.AssignRoom);
  }
}
